import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { UserStore } from "@faire/retailer-visitor-shared/stores/domain/UserStore";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { IUser } from "@faire/web-api--source/indigofair/data/IUser";
// fetch brand users "retailer" for 'View My Shop'
export var fetchBrandRetailer = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        var user, brand;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    user = UserStore.get().user;
                    brand = getGlobalProperty("brand");
                    if (!user || user.type !== IUser.Type.BRAND_USER || !(brand === null || brand === void 0 ? void 0 : brand.token)) {
                        return [
                            2
                        ];
                    }
                    return [
                        4,
                        RetailerStore.get().refetchRetailer("r_".concat(brand.token))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchBrandRetailer() {
        return _ref.apply(this, arguments);
    };
}();
